import { lazy } from "react";

import { createAinaHostBridge } from "./AinaHostBridge";
import { resolveAinaExport } from "./resolveAinaExport";

/**
 * AINA ships as a webpack Module Federation remote (`ainaService/AINAChatBot`).
 * Assets are served from `/aina-mf/*` (dev + copied into `dist/aina-mf` on build).
 */
export const AinaAppLazy = lazy(async () => {
  const mod = (await import("ainaService/AINAChatBot")) as Record<
    string,
    unknown
  >;
  const Root = resolveAinaExport(mod);
  return { default: createAinaHostBridge(Root) };
});
